import {FormControl, FormField, Separator} from 'platform/components';
import {VStack, Show} from 'platform/foundation';
import {Nullish} from 'utility-types';

import {UseFormReturn, useWatch} from 'react-hook-form';

import {isNilOrEmpty} from 'ramda-adjunct';

import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';

import {getSafely} from 'shared/web';

import {BEFORE_OPENING, BEFORE_CLOSING} from '../../../conditions/mandatoryConditions';
import {FormType, MandatoryFieldType} from '../../../types/ServiceOrderVariant';
import {getFieldsByOrderType} from '../../../utils/getFieldsByOrderType';

interface ServiceOrderMandatoryFieldsProps {
  control: FormControl<FormType>;
  formApi: UseFormReturn<FormType>;
  selectedOrderTypeCode: string | Nullish;
}

export function ServiceOrderMandatoryFields(props: ServiceOrderMandatoryFieldsProps) {
  const mandatoryFields = useWatch({
    control: props.control,
    name: 'mandatoryFields',
  });

  const handleCheckboxChange = (fieldType: MandatoryFieldType) => (value: boolean) => {
    if (!value) {
      return;
    }

    const conditionFieldValue = props.formApi.getValues(`mandatoryFieldConditions.${fieldType}`);

    if (isNilOrEmpty(conditionFieldValue)) {
      props.formApi.setValue(`mandatoryFieldConditions.${fieldType}`, [BEFORE_OPENING]);
    }
  };

  return (
    <>
      {getFieldsByOrderType(props.selectedOrderTypeCode).map((fieldType) => (
        <VStack key={fieldType} spacing={4}>
          <FormField
            control={props.control}
            label={i18n.t(`entity.order.labels.mandatoryField-${fieldType}`)}
            name={`mandatoryFields.${fieldType}`}
            type="checkbox"
            onChange={handleCheckboxChange(fieldType)}
            data-testid={testIds.settings.serviceOrderVariantsDetail(`mandatory-${fieldType}`)}
          />
          <Show
            when={getSafely(mandatoryFields, fieldType) && fieldType !== 'generatingOrderSheet'}
          >
            <FormField
              control={props.control}
              type="chips"
              options={[
                {label: i18n.t('entity.order.labels.beforeOpening'), value: BEFORE_OPENING},
                {label: i18n.t('entity.order.labels.beforeClosing'), value: BEFORE_CLOSING},
              ]}
              name={`mandatoryFieldConditions.${fieldType}`}
              data-testid={testIds.settings.serviceOrderVariantsDetail(
                `mandatoryCondition-${fieldType}`
              )}
            />
          </Show>
          <Show when={['generatingOrderSheet', 'batteryCharge'].includes(fieldType)}>
            <Separator spacing={0} />
          </Show>
        </VStack>
      ))}
    </>
  );
}
